import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-leaderboard-activity-tab',
  templateUrl: './leaderboard-activity-tab.component.html',
  styleUrls: ['./leaderboard-activity-tab.component.scss']
})
export class LeaderboardActivityTabComponent {

  @Input() userData: any;
  @Input() isOptOut: boolean = false;
  @Input() isManager: boolean = false;
  @Input() pamData: any = '';
  @Input() isActive: boolean = false;
  @Input() legacyMode: boolean = false;

}
